import { css } from "emotion";

const verticalPadding = 15;

export const modalContainer = css`
    background-color: #f7f7f7;
`;

export const ratingTitleWrapper = css`
    background-color: #fff;
    padding-left: 8px;
    padding-bottom: 5px;
`;

export const generalRateFormContainer = css`
    padding: ${verticalPadding}px 20px;
`;

export const ratingContainer = css`
    font-family: AvenirLTStd45Book;
    height: auto;
    color: rgb(122, 122, 122);
`;

export const ratingTitle = css`
    color: #b7b7b7;
    font-size: 26px;
    padding: 20px 0;
`;

export const ratingInformation = css`
    font-family: Arial, Helvetica, sans-serif;
    font-size: 12px;
`;

export const sectionTitle = css`
    font-weight: 700;
    font-size: 16px;
    font-family: AvenirLTStd45Book;
`;

export const borderLine = css`
    border-top: 1px solid #ddd;
    height: 1px;
`;

export const sectionWrapper = css`
    display: flex;
`;

export const side = css`
    flex: 1;
`;

export const rightSide = css`
    display: flex;
    justify-content: space-between;
`;

export const titleWrapper = css`
    display: flex;
    justify-content: space-between;
`;

export const input = css`
    box-sizing: border-box;
    width: 100%;
    border-radius: 5px;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 15px;
    border: 1px solid #dddddd;
    border-top: 1px solid #999;
    padding: 7.5px 15px;
    &:focus {
        border-color: #000;
    }
`;

export const inputCustom = css`
    height: 34px;
`;

export const textareaInput = css`
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    resize: vertical;
`;

export const recommendationButton = css`
    width: 80px;
    height: 34px;
    background-color: #e5e5e5;
    border: 1px solid #999 !important;
    cursor: pointer;
    background-image: -webkit-linear-gradient(
        top,
        rgba(255, 255, 255, 0.5) 0,
        rgba(255, 255, 255, 0) 100%
    );
    &:hover {
        background-color: #ddd;
    }
`;

export const recommendationButtonActive = css`
    background-color: #bbb;
`;

export const noRecommendationButton = css`
    position: relative;
    left: -1px;
    border-bottom-right-radius: 5px;
    border-top-right-radius: 5px;
`;

export const yesRecommendationButton = css`
    border-bottom-left-radius: 5px;
    border-top-left-radius: 5px;
    border-left-color: #bbb;
`;

export const ratingWrapper = css`
    max-width: 190px;
    flex-wrap: wrap;
`;

export const activeSection = css`
    background-color: #f8f0ce;
`;

export const validationLabel = css`
    margin-left: 15px;
    margin-bottom: 5px;
    flex-shrink: 0;
`;

export const submitButton = css`
    background-color: #00aced;
    color: #fff;
    border: none;
    padding: 6px 13px;
    font-family: AvenirLTStd45Book;
    font-weight: 700;
    font-size: 18px;
    cursor: pointer;
    &:hover {
        background-color: #7a7a7a;
    }
`;

export const footerStatement = css`
    margin-top: 10px;
    margin-bottom: 15px;
    font-size: 13px;
`;

export const link = css`
    color: #00aced;
    text-decoration: underline;
`;

export const termsCheckbox = css`
    opacity: 1 !important;
    position: relative !important;
    margin-right: 5px;
`;

export const termsWrapper = css`
    font-size: 13px;
    display: flex;
    align-items: center;
    margin-top: 15px;
    margin-bottom: 25px;
`;

export const termsValidationLabel = css`
    justify-content: flex-end;
`;

export const terms = css`
    display: flex;
    align-items: center;
`;